import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.iterator.map.js";
import moment from 'moment';
import confirmInsureModal from '../components/confirmInsureModal.vue';
import tableDetailModal from '../components/tableDetailModal.vue';
import batchInsure from './batchInsure.vue';
import { customerResource } from '@/views/system/customerManage/request';
import { applicationResource } from '@/views/customer/applicationManage/request';
import { insuranceResource } from '@/views/insurance/insuranceManage/request';
import { columns } from '../utils';
import { mapState } from 'vuex';
import { getInsuranceNoticeConfigResource } from '@/views/groupOrderManage/batchInsurance/request';
import { policyBatchList, failBatchDetail, getBatchPolicy } from '../request2';
export default {
  components: {
    confirmInsureModal,
    tableDetailModal,
    batchInsure
  },
  data() {
    return {
      form: {
        time: [],
        insuranceId: undefined,
        applicationId: undefined,
        customerId: undefined,
        batchPolicyNo: '',
        status: undefined
      },
      pagination: {
        showSizeChanger: true,
        showQuickJumper: true,
        total: 0,
        pageSize: 10,
        // 每页条数
        current: 1,
        showTotal: total => {
          return `${this.$t('共')} ${total} ${this.$t('条')}`;
        }
      },
      data: [],
      columns,
      customerList: [],
      productList: [],
      applicationList: [],
      confirmVisible: false,
      tableDetailVisible: false,
      toInsureData: [],
      batchVisible: false,
      failColumn: [],
      failData: [],
      templateRenderList: [],
      failClick: false,
      noticeConfigInfo: []
    };
  },
  async created() {
    this.getInsuranceNoticeConfigResourceFunc();
    if (this.$store.state.user.accountInfo.tag) {
      await this.getCustomerList();
    } else {
      this.form.customerId = this.$store.state.user.accountInfo.customerId;
      await this.customerChange();
    }
    await this.searchFun();
  },
  computed: {
    defaultValue() {
      return [moment('00:00:00', 'HH:mm:ss'), moment('23:59:59', 'HH:mm:ss')];
    },
    ...mapState({
      accountInfo: state => state.user.accountInfo
    })
  },
  methods: {
    getInsuranceNoticeConfigResourceFunc(data) {
      let params = {
        userId: this.accountInfo.id
      };
      getInsuranceNoticeConfigResource(params).then(res => {
        if (res.length > 0) {
          this.noticeConfigInfo = res;
        }
        console.log(res, 'getInsuranceNoticeConfigResourceFunc');
      });
    },
    toInsureAdd() {
      if (this.accountInfo.documentUploaded && this.noticeConfigInfo.length) {
        let validateStatus = true;
        this.noticeConfigInfo.forEach(element => {
          if (!element.noticePath) {
            validateStatus = false;
          }
        });
        if (!validateStatus) {
          this.$message.error('请上传全部的投保告知书后再投保');
          return;
        }
        if (!this.accountInfo.workScene && this.accountInfo.workSceneId) {
          this.$message.error('工作场景审核未通过，请先完成审核');
          return;
        }
      }
      this.$router.push({
        name: 'InsureAdd'
      });
    },
    range(start, end) {
      const result = [];
      for (let i = start; i < end; i++) {
        result.push(i);
      }
      return result;
    },
    openChangeDate(status) {
      if (status) {
        this.form.time = [];
      }
    },
    // 导出时间change
    onChangeExportTime(date) {
      if (date.length) {
        let startIsToday = moment(this.form.time[0]).isSame(moment(), 'days') && moment(this.form.time[0]).isAfter(moment());
        let endIsToday = moment(this.form.time[1]).isSame(moment(), 'days') && moment(this.form.time[1]).isAfter(moment());
        if (startIsToday || endIsToday) {
          if (startIsToday && endIsToday) {
            this.form.time[0] = moment();
            this.form.time[1] = moment();
          } else if (endIsToday) {
            this.form.time[1] = moment();
          }
        }
      }
    },
    disabledRangeTime(dates, type) {
      let hours = moment().hours(); //0~23
      let minutes = moment().minutes(); //0~59
      let seconds = moment().seconds(); //0~59
      //当日只能选择当前时间之后的时间点
      if (this.form.time[1] && moment(this.form.time[1]).date() === moment().date() && type === 'end' || this.form.time[0] && moment(this.form.time[0]).date() === moment().date() && type === 'start') {
        console.log(this.range(0, hours), this.range(0, minutes));
        return {
          disabledHours: () => this.range(hours + 1, 24),
          disabledMinutes: () => this.range(minutes + 1, 60),
          disabledSeconds: () => this.range(seconds + 1, 60)
        };
      }
      return {
        disabledHours: () => this.range(23, 23),
        disabledMinutes: () => this.range(59, 59),
        disabledSeconds: () => this.range(59, 59)
      };
    },
    disabledDate(current) {
      return current && moment().endOf('day') < current;
    },
    searchFun() {
      this.pagination.current = 1;
      this.getDataFun();
    },
    getDataFun() {
      let obj = {};
      obj.applicationId = this.form.applicationId;
      obj.insuranceId = this.form.insuranceId;
      obj.status = this.form.status;
      obj.customerId = this.form.customerId;
      obj.batchPolicyNo = this.form.batchPolicyNo;
      obj.page = this.pagination.current;
      obj.pageSize = this.pagination.pageSize;
      obj.createAt = this.form.time[0] ? moment(this.form.time[0]).format('YYYY-MM-DD HH:mm:ss') : '';
      obj.endAt = this.form.time[1] ? moment(this.form.time[1]).format('YYYY-MM-DD HH:mm:ss') : '';
      policyBatchList(obj).then(res => {
        this.pagination.total = res.totalNum;
        this.data = res.items;
        if (res.fieldConfig) {
          this.columns = res.fieldConfig;
        }
      });
    },
    handleStandardTableChange(val) {
      this.pagination = val;
      this.getDataFun();
    },
    async customerChange() {
      this.form.applicationId = undefined;
      if (this.form.customerId) {
        this.applicationList = await applicationResource({
          customerId: this.form.customerId,
          position: 'batch'
        });
      } else {
        this.applicationList = [];
      }
      await this.changeApplicationId();
    },
    async changeApplicationId() {
      this.form.insuranceId = undefined;
      if (this.form.applicationId) {
        this.productList = await insuranceResource({
          applicationId: this.form.applicationId
        });
      } else {
        this.productList = [];
      }
    },
    async getCustomerList() {
      this.customerList = await customerResource({});
    },
    async toInsure(data) {
      // this.toInsureData = data;
      const result = await getBatchPolicy({
        batchPolicyId: data.id,
        customerId: data.customerId
      });
      this.toInsureData = {
        customerInsuranceName: result.customerInsuranceName,
        insureCount: result.insureCount,
        totalAmount: result.totalAmount,
        totalActualAmount: result.totalActualAmount,
        id: data.id,
        customerId: data.customerId
      };
      this.confirmVisible = true;
    },
    // 点击失败明细
    async failDatail(record) {
      var _res$policyInfo;
      if (this.failClick) {
        return;
      }
      this.failClick = true;
      this.failColumn = [{
        slots: {
          title: '产品名称'
        },
        dataIndex: 'insuranceName',
        key: 'insuranceName',
        align: 'center'
      }, {
        slots: {
          title: '方案名称'
        },
        dataIndex: 'planName',
        key: 'planName',
        align: 'center'
      }, {
        slots: {
          title: '操作'
        },
        dataIndex: 'action',
        key: 'action',
        scopedSlots: {
          customRender: 'action'
        },
        align: 'center',
        width: 120
      }];
      this.failData = [];
      const res = await failBatchDetail({
        batchPolicyId: record.id,
        customerId: record.customerId
      });
      let originInfo = JSON.parse((_res$policyInfo = res.policyInfo) === null || _res$policyInfo === void 0 ? void 0 : _res$policyInfo[0].insuredInfo.originInfo);
      let insuredColumn = originInfo === null || originInfo === void 0 ? void 0 : originInfo.insured.filter(i => i.name != '与投保人关系');
      let insuredCode = [];
      if (insuredColumn.length > 3) {
        insuredColumn = insuredColumn.slice(0, 3);
      }
      insuredColumn.forEach(item => {
        insuredCode.push(item.code);
        this.failColumn.splice(this.failColumn.length - 1, 0, {
          slots: {
            title: item.name
          },
          dataIndex: item.code,
          key: item.code,
          align: 'center',
          customRender: text => {
            return {
              children: text || '—'
            };
          }
        });
      });
      this.failData = res.policyInfo.map(item => {
        item.insuranceName = res.baseInfo.insuranceName;
        item.errorMessage = [item.insureMessage];
        let data = JSON.parse(item.insuredInfo.originInfo);
        data.insured.forEach(item1 => {
          if (insuredCode.includes(item1.code)) {
            item[item1.code] = (item1 === null || item1 === void 0 ? void 0 : item1.valData1) || (item1 === null || item1 === void 0 ? void 0 : item1.valData);
          }
        });
        return item;
      });
      let templateRenderList = res.policyInfo.map(item => JSON.parse(item.insuredInfo.originInfo));
      this.templateRenderList = {
        insuranceId: record.insuranceId,
        applicationId: record.applicationId,
        customerInsuranceId: record.customerInsuranceId,
        insuredInfo: templateRenderList,
        batchPolicyId: record.id
      };
      this.tableDetailVisible = true;
      this.failClick = false;
    },
    // 批量导入
    batchImport() {
      this.batchVisible = true;
    },
    resetFun() {
      this.form.time = [];
      this.form.insuranceId = undefined;
      this.form.applicationId = undefined;
      this.form.batchPolicyNo = '';
      this.form.status = undefined;
    }
  }
};